const asyncWrapper = async operation => {
  try {
    const data = await operation();
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

const assetsMapper = assets => {
  const assetsMap = {};
  assets.keys().forEach(asset => {
    const key = asset.replace(/(.\/|.png)/g, '');
    assetsMap[key] = assets(asset);
  });
  return assetsMap;
};

const formatVoucherValue = value => Intl.NumberFormat('en', { notation: 'compact' }).format(value);

const isDevelopment = process.env.NODE_ENV === 'development';

const isQA = window.location.hostname.includes('qa');

const isDebugMode = isDevelopment || isQA;

export default { asyncWrapper, assetsMapper, formatVoucherValue, isDevelopment, isQA, isDebugMode };
